import {lazy} from 'react';
import {Navigate, type RouteObject} from 'react-router-dom';

import withSuspense from '@/routes/withSuspense';

const BoardLayout = lazy(() => import('@/pages/mngt/board/Board'));
const BoardList = lazy(() => import('@/pages/mngt/board/BoardList'));
const BoardDetail = lazy(() => import('@/pages/mngt/board/BoardDetail'));
const BoardCreate = lazy(() => import('@/pages/mngt/board/BoardCreate'));
const BoardEdit = lazy(() => import('@/pages/mngt/board/BoardEdit'));

const boardRoutes: RouteObject[] = [
  {
    path: '/mngt/board',
    element: withSuspense(<BoardLayout />),
    children: [
      {
        index: true,
        element: <Navigate to="/mngt/board/1" replace />
      },
      {
        path: ':boardId',
        element: withSuspense(<BoardList />)
      },
      {
        path: ':boardId/:id',
        element: withSuspense(<BoardDetail />)
      },
      {
        path: ':boardId/create',
        element: withSuspense(<BoardCreate />)
      },
      {
        path: ':boardId/edit/:id',
        element: withSuspense(<BoardEdit />)
      }
    ]
  }
];

export default boardRoutes;
